<template>
  <app-modal ref="modal">
    <div class="switch-formula">
      <h2 class="switch-formula__title">{{ $t('productSubpage.doYouWantToSwitchFormula') }}</h2>

      <i18n
        class="switch-formula__body u-typography-helvetica u-text u-text--s"
        tag="p"
        path="productSubpage.switchFormulaTo"
      >
        <b class="u-typography-helvetica u-text u-text--s u-text--link">{{
          $t(previousFormulaName)
        }}</b>
        <b class="u-typography-helvetica u-text u-text--s u-text--link">{{
          $t(nextFormulaName)
        }}</b>
      </i18n>

      <div class="switch-formula__actions actions">
        <u-button v-modal-submit class="actions__button">{{
          $t('productSubpage.yesSwitchLabel')
        }}</u-button>
        <u-button v-modal-cancel class="actions__button" kind="secondary">{{
          $t('action.cancel')
        }}</u-button>
      </div>
    </div>
  </app-modal>
</template>

<script>
import { UButton } from 'universkin-shared';

import AppModal from '@/components/common/AppModal.vue';

export default {
  name: 'DoYouWantToSwitchFormulaModal',
  components: { AppModal, UButton },
  props: {
    previousFormulaName: {
      type: String,
      default: ''
    },
    nextFormulaName: {
      type: String,
      default: ''
    }
  },
  methods: {
    open() {
      return this.$refs.modal.open();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/colors.scss';

.switch-formula {
  width: 90vw;
  max-width: 660px;
  padding: 48px;
  background-color: white;
  border-radius: 10px;
  text-align: center;

  &__title {
    font-family: var(--u-font-family-Helvetica);
    font-weight: 450;
    font-size: 24px;
    line-height: 30px;
    color: $tuatara-color;
    margin-bottom: 32px;
  }

  &__body {
    margin-bottom: 32px;
  }

  &__actions {
    width: 100%;
  }
}

.actions {
  &__button {
    width: 80%;
    margin: 0 auto;

    &:first-child {
      margin-bottom: 16px;
    }
  }
}

@media (min-width: 600px) {
  .actions {
    display: flex;
    flex-direction: row-reverse;

    &__button {
      flex: 1 1 0;

      &:first-child {
        margin-left: 16px;
        margin-bottom: 0;
      }
    }
  }
}
</style>
